export default __webpack_public_path__ + "static/AltinsarayEvent-832f6d86373708bd9b0823e7fe71b794.png";